import * as React from 'react';
import FormField, { BaseFormFieldProps } from './FormField';
import { PasswordInputProps } from '../input/basicInputs';
import PasswordInput from '../input/basicInputs/PasswordInput';

class PasswordInputFormField extends React.Component<BaseFormFieldProps & PasswordInputProps> {
  render() {
    return <FormField {...this.props}>{({ input }) => <PasswordInput {...input} />}</FormField>;
  }
}

export default PasswordInputFormField;
